export default function copyText(text) {
	const el = document.createElement('textarea');

	el.value = text;
	el.style.cssText = 'position: absolute; opacity: 0';
	document.body.appendChild(el);
	el.select();

	document.execCommand('copy');
	document.body.removeChild(el);
}
